import { PropsWithChildren } from 'react'
import { TextLink as DSTextLink } from '@boltenergy-be/design-system'
import { TextLinkProps } from './types'
import { Link as ReactRouterLink } from 'react-router'

const Link = ({
  as,
  children,
  href,
  destructive,
  size,
  representation,
  variant,
  external,
  trailingIcon,
  leadingIcon,
  isFullwidth,
  isFullwidthMobile,
  target,
  hideExternalIcon,
  loading,
  ref,
  onClick,
  onNavigate,
  ...nativeProps
}: PropsWithChildren<TextLinkProps>) => {
  const isAnchor = as === 'a' || external
  const DSTextLinkProps = {
    destructive,
    size,
    representation,
    variant,
    external,
    trailingIcon,
    leadingIcon,
    isFullwidth,
    isFullwidthMobile,
    hideExternalIcon,
    loading
  }

  return (
    <DSTextLink
      cloneElement={
        isAnchor ? (
          <a href={href} target={target || (external ? '_blank' : undefined)} rel="noreferrer noopener" {...nativeProps}>
            {children}
          </a>
        ) : (
          <ReactRouterLink to={href} target={target} onPointerDown={onNavigate} {...nativeProps}>
            {children}
          </ReactRouterLink>
        )
      }
      // TextLink overrides the cloned element's onClick, so handlers must go through its own onClick prop
      onClick={(event) => {
        onClick?.(event)
        if (isAnchor) onNavigate?.()
      }}
      {...DSTextLinkProps}
    />
  )
}

export default Link
